// src/lib/phone.js
// ONE phone format for the whole app: xxx-xxx-xxxx.
//
//   fmtPhone(v)      → display: "9168604198", "(916) 860-4198", "+1 916..." all
//                      render as "916-860-4198". Non-US/short values pass through.
//   fmtPhoneInput(v) → as-you-type for form fields: inserts dashes while typing
//                      and never fights deletion ("916" → "916", "9168" → "916-8").

export const fmtPhone = (v) => {
  if (v == null) return '';
  const raw = String(v).trim();
  let d = raw.replace(/\D/g, '');
  if (d.length === 11 && d.startsWith('1')) d = d.slice(1);
  if (d.length !== 10) return raw; // not a standard US number — leave it alone
  return `${d.slice(0, 3)}-${d.slice(3, 6)}-${d.slice(6)}`;
};

export const fmtPhoneInput = (v) => {
  let d = String(v || '').replace(/\D/g, '');
  if (d.length === 11 && d.startsWith('1')) d = d.slice(1);
  d = d.slice(0, 10);
  if (d.length <= 3) return d;
  if (d.length <= 6) return `${d.slice(0, 3)}-${d.slice(3)}`;
  return `${d.slice(0, 3)}-${d.slice(3, 6)}-${d.slice(6)}`;
};
